/**
 * UPSELL DRAWER CAROUSEL
 * Scroll naturel horizontal des produits upsell
 */

let isUpsellSubmitting = false; // Flag pour empêcher les soumissions multiples

// Exposer globalement pour permettre la réinitialisation après re-render
window.initUpsellCarousel = function() {
  // RÉCUPÉRATION DES ÉLÉMENTS DOM
  const container = document.querySelector('.upsell-drawer-scroll');
  const pagination = document.querySelector('.upsell-drawer-pagination');
  const dots = pagination?.querySelectorAll('.upsell-drawer-pagination_dot');
  const cards = container?.querySelectorAll('.upsell-drawer-card');
  
  if (!container) return;

  // FIX: Forcer overflow-x: auto pour le scroll naturel
  container.style.overflowX = 'auto';
  container.style.overflowY = 'hidden';
  container.style.transform = 'none';

  // MISE À JOUR DES DOTS EN FONCTION DU SCROLL
  function updateDotsOnScroll() {
    if (!dots || !cards || cards.length === 0) {
      return;
    }

    // Calculer quel produit est le plus visible
    const scrollLeft = container.scrollLeft;
    const containerCenter = scrollLeft + container.offsetWidth / 2;

    let activeIndex = 0;
    let closestDistance = Infinity;

    cards.forEach((card, index) => {
      const cardCenter = card.offsetLeft + card.offsetWidth / 2;
      const distance = Math.abs(containerCenter - cardCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        activeIndex = index;
      }
    });

    // Mettre à jour les dots
    dots.forEach((dot, index) => {
      dot.classList.toggle('is-active', index === activeIndex);
    });
  }

  // Ajouter le listener de scroll
  container.addEventListener('scroll', updateDotsOnScroll);

  // Clic sur un dot → scroll vers la carte correspondante
  if (dots && cards) {
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        if (cards[index]) {
          cards[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    });
  }

  // Initialiser les dots au chargement
  updateDotsOnScroll();

  // GESTION DES FLÈCHES (PREV / NEXT)
  const prevBtn = document.querySelector('.upsell-pagination-button.prev');
  const nextBtn = document.querySelector('.upsell-pagination-button.next');

  // Mettre à jour l'état des flèches au chargement et lors du scroll
  function updateButtonStates() {
    const maxScroll = container.scrollWidth - container.offsetWidth;
    
    if (prevBtn) prevBtn.classList.toggle('disabled', container.scrollLeft <= 0);
    if (nextBtn) nextBtn.classList.toggle('disabled', container.scrollLeft >= maxScroll - 10);
  }
  
  container.addEventListener('scroll', updateButtonStates);
  updateButtonStates();

  if (prevBtn) {
    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      container.scrollBy({ left: -300, behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      container.scrollBy({ left: 300, behavior: 'smooth' });
    });
  }

  // GESTION FORMULAIRES AJOUT PANIER ET DROPDOWNS
  
  // Gestion des dropdowns de variantes
  const variantSelects = document.querySelectorAll('.upsell-drawer-variant-select');
  
  variantSelects.forEach((select, index) => {
    select.addEventListener('change', function() {
      const productId = this.dataset.productId;
      const selectedVariantId = this.value;
      
      // Mettre à jour l'input caché du formulaire correspondant
      const variantInput = document.querySelector(`input[data-variant-input="${productId}"]`);
      
      if (variantInput) {
        variantInput.value = selectedVariantId;
      }
    });
  });
  
  // Gestion des formulaires (délégation pour survivre aux re-render du drawer)
  document.addEventListener('submit', function(e) {
    const form = e.target.closest('.upsell-drawer-form');
    if (!form) return;
    e.preventDefault();

    // ANTI-RACE-CONDITION: Vérifier si une soumission est déjà en cours
    if (isUpsellSubmitting) {
      return;
    }

    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const button = form.querySelector('.upsell-drawer-card_add');
    const originalText = button ? button.textContent : '';
    
    // Récupérer le variant ID depuis l'input name="id"
    const variantIdInput = form.querySelector('input[name="id"]');
    const variantId = variantIdInput?.value;
    
    if (!variantId) {
      console.error('❌ Aucun variant ID trouvé dans le formulaire');
      return;
    }
    
    const quantityInput = form.querySelector('input[name="quantity"]');
    const quantity = parseInt(quantityInput?.value || '1');

    if (button) {
      button.textContent = '+';
      button.disabled = true;
    }

    // Marquer comme en cours de soumission
    isUpsellSubmitting = true;

    try {
      const config = fetchConfig('javascript');
      
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      // Créer un FormData propre avec SEULEMENT id et quantity
      const cleanFormData = new FormData();
      
      cleanFormData.append('id', variantId);
      cleanFormData.append('quantity', String(quantity));

      if (cart && typeof cart.getSectionsToRender === 'function') {
        const sections = cart.getSectionsToRender();
        cleanFormData.append('sections', sections.map((section) => section.id));
        cleanFormData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') {
          cart.setActiveElement(document.activeElement);
        }
      }
      
      config.body = cleanFormData;

      const url = `${routes.cart_add_url}`;

      fetch(url, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            console.error('Erreur API:', response.description);
            if (button) {
              button.textContent = originalText;
              button.disabled = false;
            }
            isUpsellSubmitting = false;
            return;
          }

          // Mettre à jour le cart drawer avec les sections renvoyées
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(response);
          } else {
            // Fallback: publier un event cartUpdate
            try { 
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'upsell-drawer', cartData: response }); 
            } catch (error) {
              console.error('Erreur publication event:', error);
            }
          }

          // Réactiver le bouton après succès
          if (button) {
            button.textContent = '✓';
            setTimeout(() => {
              button.textContent = originalText;
              button.disabled = false;
            }, 2000);
          }

          // Libérer le flag après un court délai
          setTimeout(() => {
            isUpsellSubmitting = false;
          }, 500);
        })
        .catch((error) => {
          console.error('Erreur lors de l\'ajout au panier:', error);
          
          if (button) {
            button.textContent = '✗';
            setTimeout(() => {
              button.textContent = originalText;
              button.disabled = false;
            }, 2000);
          }
          
          // Libérer le flag en cas d'erreur
          isUpsellSubmitting = false;
        });
    } catch (error) {
      console.error('Erreur critique:', error);
      if (button) {
        button.textContent = originalText;
        button.disabled = false;
      }
      isUpsellSubmitting = false;
    }
  });
};

/**
 * UPSELL DISCOUNT BADGES (315g via metafield)
 * Fetch custom.discount_tiers via /products/{handle}?view=discount-tiers
 * Ne touche que les cartes sans badge Liquid (les 45g ont déjà leur badge)
 */
window.initUpsellDiscounts = async function() {
  var cards = document.querySelectorAll('.upsell-drawer-card[data-upsell-handle]');
  if (!cards.length) return;

  // Lire les données du panier depuis le JSON injecté par Liquid
  var cartItems = [];
  var cartDataEl = document.getElementById('upsell-cart-data');
  if (cartDataEl) {
    try { cartItems = JSON.parse(cartDataEl.textContent); } catch(e) {}
  }

  // Compter les quantités par groupe (315g) dans le panier
  function countCartGroup(keyword) {
    var total = 0;
    for (var i = 0; i < cartItems.length; i++) {
      if (cartItems[i].title.toLowerCase().indexOf(keyword) !== -1) {
        total += cartItems[i].quantity;
      }
    }
    return total;
  }

  // Formater le prix en centimes
  function formatPrice(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' \u20AC';
  }

  // Cache des fetches par handle
  var fetchCache = {};

  for (var i = 0; i < cards.length; i++) {
    var card = cards[i];

    // Skip si la carte a déjà un badge Liquid (45g)
    if (card.querySelector('.upsell-drawer-discount-badge')) continue;

    var handle = card.dataset.upsellHandle;
    var priceInCents = parseInt(card.dataset.upsellPrice, 10);
    if (!handle) continue;

    // Vérifier que c'est un 315g par le titre
    var titleEl = card.querySelector('.upsell-drawer-card_title');
    var title = titleEl ? titleEl.textContent.trim().toLowerCase() : '';
    if (title.indexOf('315g') === -1 && title.indexOf('315 g') === -1) continue;

    try {
      // Fetch le metafield via le template alternatif (avec cache)
      if (!fetchCache[handle]) {
        fetchCache[handle] = fetch('/products/' + handle + '?view=discount-tiers')
          .then(function(r) { return r.text(); })
          .then(function(text) {
            try {
              var parsed = JSON.parse(text.trim());
              return Array.isArray(parsed) ? parsed : null;
            } catch(e) {
              return null;
            }
          });
      }

      var tiers = await fetchCache[handle];
      if (!tiers || tiers.length === 0) continue;

      // Compter les 315g dans le panier + 1
      var cartQty = countCartGroup('315g');
      var futureQty = cartQty + 1;

      // Trouver le palier applicable (trié par qty décroissant)
      var sortedTiers = tiers.slice().sort(function(a, b) { return b.qty - a.qty; });
      var discountPercent = 0;
      for (var j = 0; j < sortedTiers.length; j++) {
        if (futureQty >= sortedTiers[j].qty) {
          discountPercent = sortedTiers[j].percent;
          break;
        }
      }

      if (discountPercent <= 0) continue;

      // Injecter le badge
      var imageDiv = card.querySelector('.upsell-drawer-card_image');
      if (imageDiv) {
        var badge = document.createElement('span');
        badge.className = 'upsell-drawer-discount-badge';
        badge.textContent = '-' + discountPercent + '%';
        imageDiv.appendChild(badge);
      }

      // Mettre à jour le prix avec barré + remisé
      var pricingEl = card.querySelector('.upsell-drawer-card_pricing');
      if (pricingEl && priceInCents > 0) {
        var discountAmount = Math.round(priceInCents * discountPercent / 100);
        var discountedPrice = priceInCents - discountAmount;
        pricingEl.innerHTML =
          '<span class="upsell-drawer-price-original">' + formatPrice(priceInCents) + '</span> ' +
          formatPrice(discountedPrice);
      }
    } catch(e) {
      // Skip silently
    }
  }
};

// INITIALISATION AU CHARGEMENT
document.addEventListener('DOMContentLoaded', function() {
  window.initUpsellCarousel();
  window.initUpsellDiscounts();
});
